import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Georgetown Cannabis News</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural insights in Georgetown and beyond. Our mission is to provide comprehensive coverage and educational resources to empower our community.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Explore Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the evolving landscape of cannabis legislation in Georgetown. We provide timely updates on new laws, regulations, and legal status changes.
          </p>
        </article>
        <article>
          <h2>Cannabis Culture Insights</h2>
          <p>
            Discover the cultural aspects of cannabis in our community. From events to local stories, we cover the rich tapestry of cannabis culture in Georgetown.
          </p>
        </article>
        <article>
          <h2>Educational Guides</h2>
          <p>
            Access a wealth of information about cannabis, including its benefits, usage, and legal implications. Our guides are designed to educate and inform residents and enthusiasts alike.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;